import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { MLPHeaderLink } from '../types'

interface Props {
  className?: string
  stacked?: boolean
  links: MLPHeaderLink[]
}

export const MLPHeaderLinks = ({
  stacked = false,
  links,
  className = '',
}: Props) => {
  const { colors, motion, mediaQueries } = useTheme()

  return (
    <FlexBox
      className={cx(
        css`
          justify-content: ${stacked ? 'flex-start' : 'center'};
          flex-direction: ${stacked ? 'column' : 'row'};
          flex-grow: 1;
          gap: 16px;
          ${mediaQueries.tablet} {
            gap: 32px;
          }
          ${mediaQueries.desktop} {
            gap: 40px;
          }
        `,
        className
      )}
    >
      {links.map((link, i) => (
        <AnchorLink key={i} href={`#${link.id}`} offset={140}>
          <Text
            className={css`
              font-weight: 600;
              ${motion.transition('color')};
              &:hover {
                color: ${colors.uiGraphiteLight};
              }
            `}
            type="body"
            sizing="M"
            text={link.text}
            color={colors.uiGraphite}
          />
        </AnchorLink>
      ))}
    </FlexBox>
  )
}
